import { AuspostFailureStatusProps } from '../interface/interface';
import { Tooltip } from 'react-tooltip';

export const AuspostFailureStatus = (props: AuspostFailureStatusProps) => {
  return (
    <>
      <Tooltip id="auspost-failure">{props.reason}</Tooltip>
      <span className="cursor-pointer z-[200]" data-tooltip-id="auspost-failure">
        Auspost Failure
      </span>
    </>
  );
};
